export const TagIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M1 0C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V5.586C5.66374e-05 5.8512 0.105451 6.10551 0.293 6.293L7.293 13.293C7.48053 13.4805 7.73484 13.5858 8 13.5858C8.26517 13.5858 8.51947 13.4805 8.707 13.293L13.293 8.707C13.4805 8.51947 13.5858 8.26517 13.5858 8C13.5858 7.73484 13.4805 7.48053 13.293 7.293L6.293 0.293C6.10551 0.105451 5.8512 5.66374e-05 5.586 0H1ZM5 3.5C5 3.89783 4.84197 4.27936 4.56066 4.56066C4.27936 4.84197 3.89783 5 3.5 5C3.10218 5 2.72064 4.84197 2.43934 4.56066C2.15804 4.27936 2 3.89783 2 3.5C2 3.10218 2.15804 2.72064 2.43934 2.43934C2.72064 2.15804 3.10218 2 3.5 2C3.89783 2 4.27936 2.15804 4.56066 2.43934C4.84197 2.72064 5 3.10218 5 3.5Z'
      fill='currentColor'
    />
  </svg>
);
